
import React from "react";
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { ChartContainer } from "@/components/ui/chart";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

interface SourceData {
  name: string;
  value: number;
  color: string;
}

interface SourceBreakdownChartProps {
  data: SourceData[];
}

const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 border rounded shadow-md">
        <p className="text-sm font-medium">{`${payload[0].name}`}</p>
        <p className="text-sm">{`Videos: ${payload[0].value}`}</p>
      </div>
    );
  }
  return null;
};

const EmptyState = () => (
  <div className="h-[250px] w-full flex items-center justify-center">
    <p className="text-muted-foreground">No source data available</p>
  </div>
);

const SourceBreakdownChart = ({ data }: SourceBreakdownChartProps) => {
  const hasData = data && data.length > 0 && data.some(item => item.value > 0);

  return (
    <Card className="md:col-span-1">
      <CardHeader>
        <CardTitle>Video Source Tracking</CardTitle>
        <CardDescription>
          Distribution of videos by source link origin
        </CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center">
        {!hasData ? (
          <EmptyState />
        ) : (
          <div className="h-[250px] w-full">
            <ChartContainer className="h-full" config={{}}>
              <PieChart margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  labelLine={false}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ChartContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SourceBreakdownChart;
